import { createContextFunction } from '@nartex/react-libs'

import type { DataProviders } from '../types'

export const [NxDataProvidersProvider, useNxDataProviders] =
  createContextFunction<Partial<DataProviders> | undefined>(
    'nxDataProvider',
    () => undefined,
  )
